import { render, staticRenderFns } from "./lbt.vue?vue&type=template&id=bbe44538&scoped=true"
import script from "./lbt.vue?vue&type=script&lang=js"
export * from "./lbt.vue?vue&type=script&lang=js"
import style0 from "./lbt.vue?vue&type=style&index=0&id=bbe44538&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe44538",
  null
  
)

export default component.exports